<template>
    <div>
        <img alt="" class="r:20 max-h:600 cursor:pointer" @click="open" :src="src" />
    </div>
    <Teleport to="body">
        <div v-if="isOpened">
            <div class="fixed w:full h:full bg:#333 z:$(comment-zindex) top:0 left:0 flex ai:center jc:center">
                <img alt="" class="max-w:100% max-h:100% b:0 r:0" :src="src" />
                <button class="r:100% bg:white box-shadow:0|0|20|0|black/.1 b:1|solid|#EBEBEB inline-flex ai:center jc:center w:48 h:48 fixed top:24 right:24 color:primary" @click="close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const isOpened = ref(false);

    const open = () => {
        isOpened.value = true;
    }

    const close = () => {
        isOpened.value = false;
    }

    defineProps({
        src: { required: true, type: String }
    });
</script>
